<template>
  <div class="row">
    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 pb-0">
      <ChromeSpeechToTextTextarea rows="4" max-rows="10" v-model="text" />

      <ErrorsMessages :errors="errors" />
    </div>

    <div
      class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 check-text-right"
    >
      <confirmation-dialog
        message-title="FINALIZAR COM COMPLEMENTO?"
        :message-body="`Deseja realmente finalizar a evolução?`"
        open-class="btn-save"
        open-left-icon="fa-check"
        open-text="COMPLEMENTAR E FINALIZAR"
        @yes="finish()"
      />
    </div>
  </div>
</template>

<script>
import api from "../../services/api";

import toast from "../../lib/ToastNotification";

import ChromeSpeechToTextTextarea from "../Components/ChromeSpeechToTextTextarea";

import ConfirmationDialog from "../Components/ConfirmationDialog";

import ErrorsMessages from "../Components/ErrorsMessages";

import BRyHUB from "../../lib/BRy/hub";

export default {
  name: "Finish",

  components: {
    ChromeSpeechToTextTextarea,
    ConfirmationDialog,
    ErrorsMessages,
  },

  props: {
    evolution: Object,
    complement: Number,
  },

  data() {
    return {
      text: null,
      loading: false,
      errors: [],
    };
  },

  methods: {
    async finish() {
      try {
        this.loading = true;

        const evolution_id = this.evolution.id;
        const complement = this.complement;
        const text = this.text;

        let params = { evolution_id, complement, text };

        const response = await api.post("/rest-home/evolution/finish", params);

        const { error, errors, message, id } = response.data;

        if (!error) {
          toast(message, "success");
          this.$emit("success");
          this.text = "";
          this.errors = [];

          this.$bvModal.hide("modalFinish");

          await BRyHUB.authorize({ id, table: "evolution" });
        } else {
          this.errors = errors;
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>
